import compressChatImage from './compressChatImage';

const PDF_LIMIT = 8 * 1024 * 1024;

const prepareChatFile = async (file) => {
  if (!file) throw new Error('Choose a photo or a PDF');
  const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
  if (isPdf) {
    if (file.size > PDF_LIMIT) throw new Error('PDF must be under 8 MB');
    return { file, url: '', name: file.name || 'document.pdf', kind: 'pdf' };
  }
  if (String(file.type || '').startsWith('image/')) {
    const next = await compressChatImage(file);
    return { ...next, name: file.name || 'photo.jpg', kind: 'image' };
  }
  throw new Error('Upload a photo or a PDF');
};

export const isPdfAttachment = (message) => (
  message?.kind === 'file'
  || /\.pdf$/i.test(message?.image || '')
  || /\.pdf$/i.test(message?.file_name || '')
);

export default prepareChatFile;
